import { Timestamp } from '@britishcouncil/common-core';
import {
  OsmWritingMonitoringReportResponse,
  PagedResultOfOsmWritingMonitoringReportResponse,
  api,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { OsmWritingMonitoringFilterType } from './osmWritingMonitoringReportTypes';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type ReportParams = TableState<OsmWritingMonitoringReportResponse, OsmWritingMonitoringFilterType>;

const mapQueryParams = (params: ReportParams) => ({
  ...getPaginationParameters(params),
  filter: {
    monitoringType: params.filters.monitoringType ?? [],
    monitoringResult: params.filters.monitoringResult ?? [],
    examinerIds: params.filters.examinerIds ?? [],
    startDate: params.filters.date?.[0] ? Timestamp.toISOString(params.filters.date[0]) : undefined,
    endDate: params.filters.date?.[1] ? Timestamp.toISOString(params.filters.date[1]) : undefined,
    showLastMonitorings: params.filters.showLastMonitorings ?? false,
  },
});

export const osmWritingMonitoringReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getOsmWritingMonitoringRecords: builder.query<
      PagedResultOfOsmWritingMonitoringReportResponse,
      ReportParams
    >({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.osmWritingMonitoringReport.getOsmWritingMonitoring(input);
      },
    }),
    generateOsmWritingMonitoringPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.osmWritingMonitoringReport.getOsmWritingPdfMonitoring(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateOsmWritingMonitoringExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.osmWritingMonitoringReport.getOsmWritingExcelMonitoring(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetOsmWritingMonitoringRecordsQuery,
  useGenerateOsmWritingMonitoringPdfReportMutation,
  useGenerateOsmWritingMonitoringExcelReportMutation,
} = osmWritingMonitoringReportApi;
